import type { ModelMessages } from '../de/model.js';
import { report } from './report.js';

export const model: ModelMessages = {
  report,
  libraryCategories: {
    people: 'Osoby',
    vehicles: 'Pojazdy',
    storage: 'Magazyn',
    machines: 'Maszyny',
    office: 'Biuro',
    social: 'Socjalne i sanitarne',
    outdoor: 'Teren zewnętrzny',
    misc: 'Inne',
  },
  libraryGroups: {
    sweptPaths: 'Krzywe ciągu',
    racks: 'Regały',
    loadCarriers: 'Nośniki ładunków i towary',
    cabinets: 'Szafy',
    shipping: 'Wysyłka',
    handling: 'Transport wewnętrzny',
    waste: 'Odpady',
    machining: 'Obróbka',
    welding: 'Spawanie',
    cranes: 'Żurawie',
    conveying: 'Przenośniki',
    workshop: 'Warsztat',
    utilities: 'Instalacje techniczne',
    break: 'Przerwa',
    changing: 'Szatnia',
    sanitary: 'Sanitariaty',
  },
  library: {
    person: 'Osoba',
    car: 'Samochód osobowy',
    van: 'Furgon',
    truck: 'Ciężarówka 7,5 t',
    'semi-trailer': 'Ciągnik siodłowy z naczepą',
    'swept-car': 'Krzywa ciągu – samochód osobowy',
    'swept-truck': 'Krzywa ciągu – ciężarówka 7,5 t',
    'swept-semi': 'Krzywa ciągu – ciągnik z naczepą',
    forklift: 'Wózek widłowy',
    pallet: 'Europaleta',
    'pallet-rack-1825': 'Regał paletowy 1825 mm',
    'pallet-rack': 'Regał paletowy 2700 mm',
    'pallet-rack-3600': 'Regał paletowy 3600 mm',
    'pallet-rack-5560': 'Regał paletowy 5560 mm (LTT specjalny)',
    shelf: 'Regał półkowy 3,00 m',
    'shelf-2500': 'Regał półkowy 2,50 m',
    'shelf-2000': 'Regał półkowy 2,00 m',
    'cantilever-rack': 'Regał wspornikowy jednostronny',
    'cantilever-rack-double': 'Regał wspornikowy dwustronny',
    'container-20': 'Kontener 20 ft',
    machine: 'Maszyna',
    'cnc-machine': 'Maszyna CNC',
    'welding-table-1x1': 'Stół spawalniczy 1 × 1 m',
    'welding-table-2x1': 'Stół spawalniczy 2 × 1 m',
    'welding-station': 'Stanowisko spawalnicze (kabina)',
    'truss-welding-table': 'Stół do spawania kratownic',
    workbench: 'Stół warsztatowy',
    'control-cabinet': 'Szafa sterownicza',
    desk: 'Biurko',
    tank: 'Zbiornik',
    'underfloor-saw': 'Piła podstołowa z przenośnikami rolkowymi',
    'cnc-router': 'Frezarka CNC do drewna (bramowa, 3 × 2 m)',
    'jib-crane': 'Żuraw słupowy',
    'bridge-crane': 'Suwnica pomostowa',
    'press-brake': 'Prasa krawędziowa',
    'band-saw': 'Piła taśmowa do metalu',
    'drill-press': 'Wiertarka kolumnowa',
    compressor: 'Sprężarka ze zbiornikiem',
    'dust-extractor': 'Odpylacz z filtrem',
    'mesh-box': 'Kontener siatkowy',
    'pallet-truck': 'Wózek paletowy ręczny',
    'flow-rack': 'Regał przepływowy',
    'klt-rack': 'Regał na drobne części z pojemnikami KLT',
    'packing-table': 'Stół do pakowania',
    'floor-scale': 'Waga podłogowa',
    'hazmat-cabinet': 'Szafa na substancje niebezpieczne',
    'charging-station': 'Stacja ładowania wózków',
    'press-container': 'Kontener z prasą',
    'bench-desk': 'Podwójne stanowisko pracy (bench)',
    'corner-desk': 'Biurko narożne',
    'office-chair': 'Krzesło biurowe',
    'file-cabinet': 'Szafa na akta',
    'drawer-pedestal': 'Kontener mobilny',
    'meeting-table': 'Stół konferencyjny (6 miejsc)',
    'meeting-table-4': 'Stół konferencyjny (4 miejsca)',
    'server-rack': 'Szafa serwerowa 19″ (42 U)',
    'plotter-a0': 'Ploter wielkoformatowy A0',
    'copy-station': 'Stanowisko kopiowania (kopiowanie i skanowanie)',
    'table-group-4': 'Stolik na 4 osoby',
    'table-group-8': 'Długi stół (8 miejsc, łączony)',
    kitchenette: 'Aneks kuchenny',
    fridge: 'Lodówka',
    'locker-2': 'Szafka ubraniowa 2-drzwiowa',
    'locker-3': 'Szafka ubraniowa 3-drzwiowa',
    'locker-4': 'Szafka ubraniowa 4-drzwiowa',
    'changing-bench': 'Ławka do szatni',
    shower: 'Kabina prysznicowa',
    'wc-cubicle': 'Kabina WC',
    'wash-trough': 'Umywalka zbiorowa (3 miejsca)',
    urinal: 'Pisuar',
    wc: 'Miska WC (wolnostojąca)',
    'washbasin-60': 'Umywalka z lustrem 60 cm',
    'gas-tank': 'Zbiornik gazu osłonowego (argon/CO₂)',
    'site-toilet': 'Toaleta przenośna',
    'bike-shelter': 'Wiata rowerowa',
    'ev-charger': 'Stacja ładowania EV',
    'waste-station': 'Miejsce gromadzenia odpadów',
    gatehouse: 'Portiernia ze szlabanem',
    'skip-wood-7': 'Kontener na drewno 7 m³',
    'skip-waste-10': 'Kontener na odpady zmieszane 10 m³',
    'waste-bin-1100': 'Pojemnik na odpady 1100 l',
    'tilting-skip': 'Kontener samowyładowczy do wózka widłowego',
    'recycling-station': 'Stacja segregacji odpadów (3 pojemniki)',
    'shipping-table': 'Stół wysyłkowy z rozwijakiem',
    'alu-tube-bundle': 'Wiązka rur aluminiowych 6 m',
    'pallet-stack-15': 'Stos europalet (15 szt.)',
    'steel-cabinet': 'Szafa warsztatowa dwudrzwiowa',
    'heavy-rack': 'Regał półkowy ciężki',
    'wall-jib-crane': 'Żuraw przyścienny (wysięg 4 m)',
    'work-table': 'Stół roboczy 3,0 × 1,2 m',
    'twin-head-welder': 'Spawarka dwugłowicowa 7 m',
    'truss-welding-table-partition': 'Stół do spawania kratownic ze ścianką działową',
    'roller-conveyor': 'Przenośnik rolkowy 3 m',
    'tool-wall': 'Tablica narzędziowa (ścienna)',
    'tool-trolley': 'Wózek narzędziowy',
    'desk-plain': 'Biurko (bez komputera)',
    sideboard: 'Komoda biurowa',
    'fire-extinguisher': 'Gaśnica ze znakiem',
    'first-aid-station': 'Punkt pierwszej pomocy',
    'emergency-shower': 'Prysznic bezpieczeństwa z oczomyjką',
    'welding-screen': 'Ścianka osłonowa spawalnicza 3 × 2 m',
    'pallet-boxes-1x1': 'Paleta z kartonami 1 × 1 m (16 szt.)',
    'truss-carton-pallet': 'Paleta z kartonami kratownic (28 szt.)',
    'pallet-carton-1x1': 'Paleta z kartonem 1 × 1 m',
    'pallet-carton-2x1': 'Paleta z kartonem 2 × 1 m',
  },
  openings: {
    'sectional-door': 'Brama segmentowa',
    'rolling-door': 'Brama rolowana przemysłowa',
    'rapid-door': 'Brama szybkobieżna',
    'fire-gate': 'Brama przesuwna przeciwpożarowa',
    door: 'Drzwi',
    'double-door': 'Drzwi dwuskrzydłowe',
    'glass-door': 'Drzwi szklane',
    'glass-double-door': 'Drzwi szklane dwuskrzydłowe',
    passage: 'Przejście w ścianie',
    'double-passage': 'Szerokie przejście w ścianie',
    window: 'Okno',
    'window-band': 'Pasmo okienne',
    'loading-dock': 'Rampa załadunkowa',
    void: 'Otwarta część ściany',
  },
  zoneCategories: {
    production: 'Produkcja',
    storage: 'Magazyn',
    'goods-in': 'Przyjęcie towaru',
    'goods-out': 'Wydanie towaru',
    assembly: 'Montaż',
    packaging: 'Pakowanie',
    office: 'Biuro',
    social: 'Pomieszczenie socjalne',
    technical: 'Technika',
    workshop: 'Warsztat',
    'open-space': 'Powierzchnia wolna',
    'truck-access': 'Dojazd ciężarówek',
    'forklift-path': 'Droga wózków widłowych',
    walkway: 'Ciąg pieszy',
    'escape-route': 'Droga ewakuacyjna',
    'work-area': 'Strefa robocza',
    paving: 'Powierzchnia z kostki',
    green: 'Teren zielony',
    gravel: 'Powierzchnia żwirowa',
    'crushed-stone': 'Powierzchnia z tłucznia',
    asphalt: 'Powierzchnia asfaltowa',
    concrete: 'Powierzchnia betonowa',
    other: 'Inne',
  },
  zoneGroups: {
    function: 'Powierzchnie funkcyjne',
    traffic: 'Powierzchnie komunikacyjne',
    surface: 'Nawierzchnie i tereny zielone',
  },
  fenceKinds: {
    mesh: 'Panele zgrzewane 2D',
    mobile: 'Ogrodzenie budowlane (mobilne)',
  },
  wallTypes: {
    drywall: 'Sucha zabudowa 12,5 cm',
    'masonry-115': 'Silikat 11,5 cm',
    'masonry-175': 'Silikat 17,5 cm',
    'masonry-24': 'Silikat 24 cm',
    'concrete-20': 'Beton 20 cm',
    'concrete-25': 'Beton 25 cm',
    'brick-24': 'Klinkier 24 cm',
    sandwich: 'Płyta warstwowa 15 cm (pionowo)',
    'sandwich-horizontal': 'Płyta warstwowa 15 cm (poziomo)',
  },
  roomTypes: {
    office: 'Biuro',
    meeting: 'Sala spotkań',
    kitchen: 'Aneks kuchenny / przerwa',
    'wc-women': 'WC damskie',
    'wc-men': 'WC męskie',
    'wc-accessible': 'WC dla niepełnosprawnych',
    changing: 'Szatnia',
    shower: 'Natrysk',
    corridor: 'Korytarz',
    technical: 'Pomieszczenie techniczne',
    storage: 'Magazyn / archiwum',
    other: 'Pomieszczenie',
  },
  roomTemplates: {
    'corridor-offices': {
      label: 'Korytarz z biurami',
      hint: 'Korytarz 1,50 m wzdłuż, biura o szerokości ok. 3,60 m po obu stronach (w wąskich budynkach po jednej).',
    },
    social: {
      label: 'Część socjalna',
      hint: 'Korytarz 1,50 m wzdłuż, do tego WC damskie/męskie/dla niepełnosprawnych, szatnie, natrysk i aneks kuchenny.',
    },
  },
  roads: {
    road: 'Droga',
    'truck-access': 'Dojazd ciężarówek',
    'fire-lane': 'Droga pożarowa',
    footpath: 'Chodnik',
  },
  parkings: {
    car: 'Parking dla samochodów osobowych',
    truck: 'Miejsca postojowe dla ciężarówek',
  },
  roofElements: {
    'skylight-dome': 'Świetlik kopułkowy',
    'skylight-band': 'Pasmo świetlne',
    'smoke-vent': 'Świetlik oddymiający',
  },
  stairTypes: {
    straight: 'Schody proste',
    u: 'Schody dwubiegowe (U)',
    l: 'Schody dwubiegowe kątowe (L)',
  },
  sides: {
    south: 'Ściana południowa',
    east: 'Ściana wschodnia',
    north: 'Ściana północna',
    west: 'Ściana zachodnia',
  },
  levels: {
    ground: 'Parter',
    upper: 'Piętro {n}',
    top: 'Piętro {n} (antresola)',
  },
  sectionName: 'Obszar {letter}',
  warnings: {
    overplanned: 'W {name} zaplanowano więcej powierzchni, niż jest dostępne',
    officeOutsideHall: '{name} jest zaplanowany jako zabudowa, ale nie stoi w całości w hali',
    officeAboveEave: '{name} ({height}) jest wyższy niż okap {hall} ({eave})',
    officeLowAir: '{name} ({height}) pozostawia pod okapem {hall} tylko {air} prześwitu',
    stair: '{name}: {hint}',
    buildingOutsideSite: '{name} nie leży w całości na działce',
    sitesOverlap: 'Działki nachodzą na siebie – powierzchnia zostałaby policzona podwójnie',
    overlap: '{a} i {b} nachodzą na siebie',
  },
  dock: {
    steep: 'Rampa o spadku {pct} % jest bardziej stroma niż 10 % – naczepa może uderzyć w ścianę',
    narrow: 'Dojazd do rampy ma tylko {width} m szerokości (co najmniej {min} m)',
    short: 'Stanowisko rampy ma tylko {length} m długości (co najmniej {min} m)',
    narrowerThanGate: 'Dojazd do rampy jest węższy niż brama',
    levelerWider: 'Pomost przeładunkowy jest szerszy niż brama',
    offSite: 'Dojazd do rampy wystaje poza działkę',
    overlap: 'Dwa dojazdy do ramp nachodzą na siebie – rozsuń bramy',
  },
  costs: {
    title: 'Ilości i szacunek kosztów',
    columns: ['Pozycja', 'Ilość', 'Cena jedn.', 'Kwota'],
    units: { t: 't', m2: 'm²', m3: 'm³', pcs: 'szt.', kWp: 'kWp' },
    perUnit: { t: '€/t', m2: '€/m²', m3: '€/m³', pcs: '€/szt.', kWp: '€/kWp' },
    items: {
      steel: 'Konstrukcja stalowa (z montażem)',
      concrete: 'Żelbet: beton C30/37 (wbudowany)',
      rebar: 'Żelbet: stal zbrojeniowa (ułożona)',
      formwork: 'Żelbet: deskowanie',
      precast: 'Prefabrykaty betonowe (słupy, dźwigary, podciągi, z montażem)',
      roofSandwich: 'Dach z płyt warstwowych',
      roofFlat: 'Dach płaski (blacha, izolacja, hydroizolacja)',
      wallSandwich: 'Ściana z płyt warstwowych',
      wallTrapezoid: 'Ściana z blachy trapezowej',
      wallMasonry: 'Mur (silikat, tynkowany)',
      wallBrick: 'Mur z klinkieru',
      wallDrywall: 'Ściana g-k',
      hallFloor: 'Płyta posadzki / posadzka przemysłowa',
      mezzanine: 'Antresola (stal)',
      gate: 'Brama segmentowa / rolowana',
      fireGate: 'Brama przesuwna ppoż.',
      rapidDoor: 'Brama szybkobieżna',
      dock: 'Brama przeładunkowa z rampą',
      door: 'Drzwi',
      doubleDoor: 'Drzwi dwuskrzydłowe',
      window: 'Okno / pas okienny (ściana)',
      skylight: 'Świetlik kopułkowy',
      skylightBand: 'Pasmo świetlne (dach)',
      smokeVent: 'Klapa dymowa',
      pv: 'Instalacja PV na dachu (moduły, konstrukcja, falowniki, z montażem)',
    },
    surcharges: {
      foundations: 'Fundamenty i roboty ziemne',
      services: 'Instalacje',
      fees: 'Koszty dodatkowe (projekt, opłaty)',
    },
    measured: 'Suma pozycji z planu',
    surcharge: '{label} ({percent} %)',
    total: 'Razem (netto)',
    range: 'Zakres (± {percent} %)',
    notesTitle: 'Założenia i ograniczenia',
    steelDetail:
      'Stal: ramy {frame} t, płatwie/rygle {secondary} t, stężenia {bracing} t, słupy {columns} t, połączenia {extra} t',
    concreteDetail:
      'Żelbet: stropy {slab} m³, podciągi {beam} m³, słupy {column} m³, ściany {wall} m³, fundamenty {foundation} m³; zbrojenie {rebar} t (wskaźniki na m³)',
    priceBasis: 'Podstawa cen: katalog „{name}”, uzupełniony o własne ceny tego projektu',
    precastDetail:
      'Prefabrykaty: {volume} m³ słupów, dźwigarów i podciągów hal, ze zbrojeniem i montażem',
    replacedPrices:
      'Własne ceny stropów, ścian betonowych i słupów betonowych już nie obowiązują: żelbet jest teraz liczony jako beton, stal zbrojeniowa i deskowanie.',
    notes: [
      'Szacunek kosztów z ilości planu i cen jednostkowych tego projektu, netto bez VAT.',
      'Nieuwzględnione: roboty ziemne, fundamenty (o ile nie wyznaczono ich ze słupów), instalacje, zagospodarowanie terenu, wykończenie i koszty dodatkowe, o ile nie dodano ich jako narzut.',
      'Masa stali, ilości żelbetu i fundamenty ze wstępnego wymiarowania; nie zastępują obliczeń statycznych ani oferty.',
    ],
  },
  collisions: {
    overlap: '{a} nachodzi na {b}',
    wall: '{a} przenika przez ścianę',
    lining: '{a} wchodzi w okładzinę ściany',
    column: '{a} stoi w miejscu słupa',
    clearance: 'Przestrzeń wolna obiektu {a} jest zajęta przez {b}',
    clearanceWall: 'Przestrzeń wolna obiektu {a} sięga w ścianę',
  },
  stairHints: {
    steep: 'Wysokość stopnia powyżej 19 cm – schody zbyt strome',
    stepRule: 'Reguła kroku {value} cm poza zakresem 59–65 cm',
    narrow: 'Szerokość biegu poniżej 1,00 m – zwykle za wąska dla drogi ewakuacyjnej',
    landingNeeded: '{n} stopni w jednym biegu – po najwyżej 18 stopniach potrzebny jest spocznik',
  },
  hallStructure: {
    trussGirder:
      'Dźwigar stalowy o rozpiętości ponad {span} m: kratownica jest zwykle bardziej ekonomiczna niż kształtownik walcowany',
    precastSpan:
      'Dźwigary sprężone ponad {span} m są nietypowe – przewidzieć słupy pośrednie lub zaprojektować w stali',
    steepPrecast:
      'Nachylenie dachu {pitch}°: sprężone dźwigary dwuspadowe mają zwykle spadek 3–5 %; tutaj spód dźwigara wznosi się ku kalenicy',
  },
  officeStructure: {
    slabThin:
      '{name}: strop {thickness} cm jest za cienki dla rozpiętości {span} m – zalecane ok. {recommended} cm',
    wideSpan:
      '{name}: stropy mają rozpiętość {span} m między ścianami nośnymi – przewidzieć słupy, podciąg lub nośną ścianę wewnętrzną',
    unsupported:
      '{name}: {n} słupów na kondygnacji {level} stoi bez słupa poniżej – potrzebna belka przejmująca',
    hallColumn: '{name}: słup hali w osi {axis} stoi w budynku biurowym',
    hallGableColumn: '{name}: słup ściany szczytowej hali stoi w budynku biurowym',
    headroom: '{name}: sięga do {top} m, konstrukcja hali powyżej zaczyna się już na {steel} m',
  },
  plan: {
    unassigned: 'Nieprzypisane',
    terrace: 'Taras na dachu',
    roof: 'Dach',
    stairFrom: 'od {level}',
    stairSteps: '{n} st. {riser}/{going}',
    stalls: {
      one: '{n} miejsce postojowe',
      few: '{n} miejsca postojowe',
      many: '{n} miejsc postojowych',
      other: '{n} miejsca postojowego',
    },
    area: 'Obszar {n}',
    stairwell: 'Klatka schodowa',
    gfaStorey: 'PCB {level} {area} · razem {total}',
    netArea: 'Wewnątrz {area}',
    officeTitle: '{name} · kondygnacje: {n} · {info}',
    floors: {
      one: '{n} kondygnacja · {height}',
      few: '{n} kondygnacje · {height}',
      many: '{n} kondygnacji · {height}',
      other: '{n} kondygnacji · {height}',
    },
    levelClearHeight: '{level} · wysokość w świetle {height}',
    gfa: 'Pow. całk. {area}',
    eave: 'Okap {height}',
    eaveRidge: 'Okap {eave} · kalenica {ridge}',
    roomHeight: '{area} · wys. {height}',
  },
  errors: {
    hallLocked: 'Hala jest zablokowana',
    shellLocked: 'Bryła „{name}” jest chroniona (najpierw zwolnij ją we właściwościach)',
    hallCornersMin: 'Hala potrzebuje co najmniej trzech narożników',
    mezzanineOutside: 'Antresola musi leżeć całkowicie wewnątrz hali',
    mezzanineHeight:
      'Wysokość antresoli musi być większa od grubości stropu i co najmniej 2 m poniżej okapu',
    mezzanineShape: 'Antresola potrzebuje co najmniej trzech narożników i nie może się przecinać',
    mezzanineLocked: 'Antresola jest zablokowana',
    mezzanineNoFreeEdge: 'Antresola nie ma wolnej krawędzi na schody',
    canopyNoFit: 'Daszek jest szerszy niż ściana',
    canopyLocked: 'Daszek jest zablokowany',
    wallImageLocked: 'Obraz ścienny jest zablokowany',
    officeLocked: 'Budynek biurowy jest zablokowany',
    ownedWall: 'Ta ściana jest sterowana przez swoją halę lub pomieszczenie',
    rectRoomsOnly: 'Edytować można tylko prostokątne pomieszczenia',
    noSpace: 'Brak miejsca na {type} ({width} m) w tej ścianie',
    rowTooLong: '{n} × {type} nie mieści się w ścianie (potrzeba {total} m)',
    gateTooWide: 'Ogrodzenie jest krótsze niż brama ({width} m)',
    rowOverlap: 'Rząd nachodzi na istniejące otwory – zmień odstęp lub liczbę',
    stairNeedsOffice: 'Schody należą do budynku biurowego',
    storeyOutlineLevel: 'Własny obrys mogą mieć tylko wyższe kondygnacje',
    storeyOutlineOutside:
      'Obrys kondygnacji musi leżeć na kondygnacji poniżej i mieć co najmniej 4 m²',
    noUpperLevel: 'Nad tą kondygnacją nie ma kolejnej',
    stairLocked: 'Schody są zablokowane',
    lineGone: 'Linia już nie istnieje',
    pointGone: 'Punkt nie istnieje',
    segmentGone: 'Odcinek nie istnieje',
    lineMinPoints: 'Linia wymaga co najmniej dwóch punktów',
    lineMaxPoints: 'Zbyt wiele punktów w jednej linii',
    hallGone: 'Hala nie istnieje',
    roofNoFit: 'Przy tych odstępach żaden element „{type}” nie mieści się na dachu',
    polygonMinPoints: 'Wielokąt wymaga co najmniej trzech punktów',
    socialTooSmall: 'Kondygnacja jest za mała na część socjalną (min. ok. 6 m długości)',
    templatesOfficeOnly: 'Szablony pomieszczeń są dostępne tylko dla budynków biurowych',
    noInterior: 'Ta kondygnacja nie ma wnętrza',
    templatesOrthogonal:
      'Szablony pomieszczeń działają tylko dla budynków ustawionych równolegle do siatki',
    levelHasRooms: '{level} ma już pomieszczenia – najpierw je usuń',
    refSiteGone: 'Działka odniesienia już nie istnieje',
    siteGone: 'Działka już nie istnieje',
    nothingToTakeOver: 'Plik nie zawiera ani działek, ani obrazu tła',
    siteLocked: 'Działka jest zablokowana',
    noBackground: 'Brak obrazu tła',
    backgroundLocked: 'Obraz tła jest zablokowany',
    lengthPositive: 'Podaj długość większą od 0',
  },
  commands: {
    moveSelection: 'Przesuń zaznaczenie',
    rotate: 'Obróć',
    rotateSelection: 'Obróć zaznaczenie',
    removeSelection: 'Usuń zaznaczenie',
    remove: 'Usuń',
    lock: 'Zablokuj',
    unlock: 'Odblokuj',
    protectShell: 'Chroń bryłę',
    releaseShell: 'Zwolnij bryłę',
    alignObjects: 'Wyrównaj obiekty',
    distributeEven: 'Rozmieść równomiernie',
    distributeGap: 'Rozmieść ze stałym odstępem',
    paste: 'Wklej',
    updateProject: 'Zmień dane projektu',
    updateSettings: 'Zmień ustawienia',
    addElement: 'Dodaj element',
    updateElement: 'Zmień element',
    createHall: 'Utwórz halę',
    moveHall: 'Przesuń halę',
    updateHall: 'Zmień halę',
    resizeHall: 'Zmień rozmiar hali',
    createMezzanine: 'Utwórz antresolę',
    restoreWalls: 'Przywróć ściany zewnętrzne',
    createCanopy: 'Utwórz daszek',
    updateCanopy: 'Zmień daszek',
    createWallImage: 'Dodaj obraz na ścianę',
    updateWallImage: 'Zmień obraz ścienny',
    openWall: 'Otwórz całą ścianę',
    createRailing: 'Utwórz balustradę',
    updateMezzanine: 'Zmień antresolę',
    createOffice: 'Utwórz budynek biurowy',
    updateOffice: 'Zmień budynek biurowy',
    openWallFloor: 'Otwórz ścianę zewnętrzną na jednej kondygnacji',
    closeWallFloor: 'Zamknij ścianę zewnętrzną na jednej kondygnacji',
    setStoreyOutline: 'Narysuj obrys kondygnacji',
    resetStoreyOutline: 'Przywróć obrys kondygnacji',
    updateFloors: 'Zmień kondygnacje',
    updateFloorHeight: 'Zmień wysokość kondygnacji',
    drawWall: 'Rysuj ścianę',
    moveWall: 'Przesuń ścianę',
    updateWall: 'Zmień ścianę',
    rotateWall: 'Obróć ścianę',
    wallLength: 'Zmień długość ściany',
    createRoom: 'Utwórz pomieszczenie',
    updateRoom: 'Zmień pomieszczenie',
    moveRoom: 'Przesuń pomieszczenie',
    resizeRoom: 'Zmień rozmiar pomieszczenia',
    recalcRoomWalls: 'Przelicz ściany pomieszczenia',
    roomLayout: 'Wstaw podział pomieszczeń',
    createZone: 'Utwórz strefę',
    updateZone: 'Zmień strefę',
    moveZone: 'Przesuń strefę',
    resizeZone: 'Zmień rozmiar strefy',
    insertOpening: 'Wstaw: {type}',
    insertDoubleDock: 'Wstaw rampę podwójną',
    changeOpeningType: 'Zmień typ otworu',
    updateOpening: 'Zmień otwór',
    moveOpening: 'Przesuń otwór',
    openingWidth: 'Zmień szerokość otworu',
    openingLevel: 'Zmień kondygnację otworu',
    updateDock: 'Zmień rampę załadunkową',
    saveMeasurement: 'Zapisz wymiar',
    updateMeasurement: 'Zmień wymiar',
    moveMeasurement: 'Przesuń wymiar',
    insertObject: 'Wstaw: {name}',
    updateObject: 'Zmień obiekt',
    moveObject: 'Przesuń obiekt',
    moveObjects: 'Przesuń obiekty',
    hideObjects: 'Ukryj obiekty',
    showObjects: 'Pokaż obiekty',
    placeElement: 'Umieść: {type}',
    extendRoad: 'Przedłuż drogę',
    extendFence: 'Przedłuż ogrodzenie',
    liftObject: 'Podnieś obiekt',
    rotateObject: 'Obróć obiekt',
    duplicateObject: 'Duplikuj obiekt',
    duplicateRoofElements: 'Duplikuj element dachu',
    createColumn: 'Wstaw słup',
    updateColumn: 'Zmień słup',
    moveColumn: 'Przesuń słup',
    detachColumns: 'Edytuj słupy pojedynczo',
    restoreColumns: 'Przywróć automatyczne słupy',
    resizeObject: 'Zmień rozmiar',
    objectSize: 'Zmień rozmiar obiektu',
    updateClearance: 'Zmień przestrzeń wolną',
    changeLevel: 'Zmień kondygnację',
    updateColor: 'Zmień kolor',
    restoreSize: 'Przywróć rozmiar oryginalny',
    insertStair: 'Wstaw schody',
    insertStairWithDoor: 'Wstaw schody ze spocznikiem i drzwiami',
    updateStair: 'Zmień schody',
    moveStair: 'Przesuń schody',
    rotateStair: 'Obróć schody',
    updateLanding: 'Zmień spocznik',
    createOutdoor: 'Utwórz: {type}',
    createFence: 'Utwórz ogrodzenie',
    movePoint: 'Przesuń punkt',
    insertPoint: 'Wstaw punkt',
    deletePoint: 'Usuń punkt',
    moveSitePoint: 'Przesuń punkt działki',
    insertSitePoint: 'Wstaw punkt działki',
    deleteSitePoint: 'Usuń punkt działki',
    moveZonePoint: 'Przesuń punkt strefy',
    insertZonePoint: 'Wstaw punkt strefy',
    deleteZonePoint: 'Usuń punkt strefy',
    edgeLength: 'Zmień długość krawędzi',
    roadKind: 'Zmień rodzaj drogi',
    roadWidth: 'Zmień szerokość drogi',
    moveRoad: 'Przesuń drogę',
    resizeRoad: 'Droga: zmień rozmiar',
    fenceHeight: 'Zmień wysokość ogrodzenia',
    fenceStyle: 'Zmień ogrodzenie',
    addGate: 'Wstaw bramę przesuwną',
    addFenceDoor: 'Wstaw furtkę',
    moveGate: 'Przesuń bramę przesuwną',
    updateGate: 'Zmień bramę przesuwną',
    removeGate: 'Usuń bramę przesuwną',
    moveFence: 'Przesuń ogrodzenie',
    resizeFence: 'Ogrodzenie: zmień rozmiar',
    updateParking: 'Zmień parking',
    moveParking: 'Przesuń parking',
    rotateParking: 'Obróć parking',
    resizeParking: 'Zmień rozmiar parkingu',
    updateRoofElement: 'Zmień element dachowy',
    moveRoofElement: 'Przesuń element dachowy',
    removeRoofElements: 'Usuń elementy dachowe',
    createSite: 'Utwórz działkę',
    replaceSite: 'Zastąp działkę',
    takeOverSites: 'Przejmij działkę i tło',
    attachSite: 'Dołącz działkę',
    rotateSite: 'Obróć działkę',
    updateSite: 'Zmień działkę',
    renameSite: 'Zmień nazwę działki',
    moveSite: 'Przesuń działkę',
    siteShape: 'Zmień kształt działki',
    updateBackground: 'Zmień obraz tła',
    insertBackground: 'Wstaw obraz tła',
    removeBackground: 'Usuń obraz tła',
    calibrateBackground: 'Ustal skalę obrazu tła',
    rotateBackground: 'Obróć obraz tła',
    lockBackground: 'Zablokuj obraz tła',
    unlockBackground: 'Odblokuj obraz tła',
    alignBackground: 'Wyrównaj obraz tła',
    moveBackground: 'Przesuń obraz tła',
  },
  defaults: {
    hall: 'Hala {n}',
    office: 'Budynek biurowy {n}',
    site: 'Działka',
    siteNumbered: 'Działka {n}',
    room: 'Pomieszczenie {n}',
    fence: 'Ogrodzenie',
    gate: 'Brama przesuwna',
    fenceDoor: 'Furtka',
    siteFence: 'Ogrodzenie działki',
    copy: '{name} (kopia)',
    officeRoom: 'Biuro {n}',
    changingWomen: 'Szatnia damska',
    changingMen: 'Szatnia męska',
  },
  parse: {
    notObject: 'Plik projektu nie jest obiektem',
    missingVersion: 'Brak schemaVersion lub wartość nieprawidłowa',
    tooNew: 'Projekt utworzono w nowszej wersji (schemat {version}, obsługiwany {target})',
    missingMigration: 'Brak migracji ze schematu {version}',
    invalidData: 'Dane projektu są nieprawidłowe',
    invalidJson: 'Plik nie jest prawidłowym JSON',
  },
  issues: {
    idMismatch: 'ID nie zgadza się z kluczem',
    idDuplicate: 'ID nie jest unikalne',
    siteBoundary: 'Granica działki nie jest prawidłowym wielokątem',
    wallTooThick: 'Grubość ściany jest za duża w stosunku do wymiarów hali',
    hallOutline: 'Obrys budynku nie może się przecinać i musi mieć co najmniej 4 m²',
    hallOutlineRoof: 'Swobodnie rysowane hale mają tylko dach płaski lub jednospadowy',
    mezzanineNoHall: 'Antresola bez przypisanej hali',
    columnNoBuilding: 'Słup bez przypisanej hali lub kondygnacji',
    mezzaninePolygon: 'Nieprawidłowy obrys antresoli',
    mezzanineHeight: 'Wysokość antresoli nie pasuje do hali',
    canopyWall: 'Daszek bez przypisanej ściany',
    wallImageWall: 'Obraz ścienny bez przypisanej ściany',
    canopyPastEnd: 'Daszek wystaje poza koniec ściany',
    railingRoof: 'Balustrada dachowa bez przypisanego budynku',
    officeData: 'Dane kondygnacji nie pasują do rodzaju budynku',
    officeHeight: 'Wysokość budynku nie pasuje do kondygnacji',
    stairNoOffice: 'Schody nie należą do żadnego budynku biurowego',
    noUpperLevel: 'Nad tą kondygnacją nie ma kolejnej',
    roofElementNoHall: 'Element dachowy nie należy do żadnej hali',
    roofElementOutside: 'Element dachowy wystaje poza dach',
    duplicatePoints: 'Dwa kolejne punkty są identyczne',
    wallLength: 'Długość ściany musi być większa od 0',
    wallOwner: 'Ściana odwołuje się do nieznanej hali lub pomieszczenia',
    openingWall: 'Otwór odwołuje się do nieistniejącej ściany',
    openingPastEnd: 'Otwór wystaje poza koniec ściany',
    openingTooHigh: 'Otwór jest wyższy niż ściana',
    openingsOverlap: 'Otwory w tej samej ścianie nachodzą na siebie',
    unknownHall: 'Odwołanie do nieznanej hali',
    zonePolygon: 'Nieprawidłowy wielokąt strefy',
    roomPolygon: 'Nieprawidłowy wielokąt pomieszczenia',
  },
};
